function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "logos/figma"
}, React.createElement("g", {
  id: "figma"
}, React.createElement("path", {
  id: "path0 fill",
  d: "M11.25 32C14.424 32 17 29.6107 17 26.6667V21.3333H11.25C8.076 21.3333 5.5 23.7227 5.5 26.6667C5.5 29.6107 8.076 32 11.25 32Z",
  fill: "#0ACF83"
}), React.createElement("path", {
  id: "path1 fill",
  d: "M5.5 16C5.5 13.056 8.076 10.6667 11.25 10.6667H17V21.3333H11.25C8.076 21.3333 5.5 18.944 5.5 16Z",
  fill: "#A259FF"
}), React.createElement("path", {
  id: "path1 fill 1",
  d: "M5.5 5.33333C5.5 2.38933 8.076 0 11.25 0H17V10.6667H11.25C8.076 10.6667 5.5 8.27733 5.5 5.33333Z",
  fill: "#F24E1E"
}), React.createElement("path", {
  id: "path2 fill",
  d: "M17 0H22.75C25.924 0 28.5 2.38933 28.5 5.33333C28.5 8.27733 25.924 10.6667 22.75 10.6667H17V0Z",
  fill: "#FF7262"
}), React.createElement("path", {
  id: "path3 fill",
  d: "M28.5 16C28.5 18.944 25.924 21.3333 22.75 21.3333C19.576 21.3333 17 18.944 17 16C17 13.056 19.576 10.6667 22.75 10.6667C25.924 10.6667 28.5 13.056 28.5 16Z",
  fill: "#1ABCFE"
})));

var SvgFigma = function SvgFigma(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImxvZ29zL2ZpZ21hIj4KPGcgaWQ9ImZpZ21hIj4KPHBhdGggaWQ9InBhdGgwIGZpbGwiIGQ9Ik0xMS4yNSAzMkMxNC40MjQgMzIgMTcgMjkuNjEwNyAxNyAyNi42NjY3VjIxLjMzMzNIMTEuMjVDOC4wNzYgMjEuMzMzMyA1LjUgMjMuNzIyNyA1LjUgMjYuNjY2N0M1LjUgMjkuNjEwNyA4LjA3NiAzMiAxMS4yNSAzMloiIGZpbGw9IiMwQUNGODMiLz4KPHBhdGggaWQ9InBhdGgxIGZpbGwiIGQ9Ik01LjUgMTZDNS41IDEzLjA1NiA4LjA3NiAxMC42NjY3IDExLjI1IDEwLjY2NjdIMTdWMjEuMzMzM0gxMS4yNUM4LjA3NiAyMS4zMzMzIDUuNSAxOC45NDQgNS41IDE2WiIgZmlsbD0iI0EyNTlGRiIvPgo8cGF0aCBpZD0icGF0aDEgZmlsbCAxIiBkPSJNNS41IDUuMzMzMzNDNS41IDIuMzg5MzMgOC4wNzYgMCAxMS4yNSAwSDE3VjEwLjY2NjdIMTEuMjVDOC4wNzYgMTAuNjY2NyA1LjUgOC4yNzczMyA1LjUgNS4zMzMzM1oiIGZpbGw9IiNGMjRFMUUiLz4KPHBhdGggaWQ9InBhdGgyIGZpbGwiIGQ9Ik0xNyAwSDIyLjc1QzI1LjkyNCAwIDI4LjUgMi4zODkzMyAyOC41IDUuMzMzMzNDMjguNSA4LjI3NzMzIDI1LjkyNCAxMC42NjY3IDIyLjc1IDEwLjY2NjdIMTdWMFoiIGZpbGw9IiNGRjcyNjIiLz4KPHBhdGggaWQ9InBhdGgzIGZpbGwiIGQ9Ik0yOC41IDE2QzI4LjUgMTguOTQ0IDI1LjkyNCAyMS4zMzMzIDIyLjc1IDIxLjMzMzNDMTkuNTc2IDIxLjMzMzMgMTcgMTguOTQ0IDE3IDE2QzE3IDEzLjA1NiAxOS41NzYgMTAuNjY2NyAyMi43NSAxMC42NjY3QzI1LjkyNCAxMC42NjY3IDI4LjUgMTMuMDU2IDI4LjUgMTZaIiBmaWxsPSIjMUFCQ0ZFIi8+CjwvZz4KPC9nPgo8L3N2Zz4K";
export { SvgFigma as ReactComponent };